<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wA39u9/tc-custom/9781788633031.jpg?1701486931180" alt="This image is the cover for the book Let It Shine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Let It Shine
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A historical novel set between the wars in which a woman makes amends to a family beset by tragedy is “another hit” for this bestselling English novelist (<i>The Daily Telegraph</i>).</b><br/><br/> Ada Williams once believed money and power would bring her happiness. But now she is all alone except for her greedy son Peter, who waits only for the day he will inherit her fortune. Ada, however, has a different plan altogether.<br/>  <br/> A few miles away in Blackburn, the Bolton family may be poor—but the love they share means they can overcome almost any adversity. But no one could foresee the shocking culmination of events on Christmas night, 1932, events begun many years ago which split the family asunder, leaving Larry injured and the twins, Ellie and Betsy, in a foster home. Ada Williams was young and foolish then, but her plan will see a reversal of fates for the Bolton family in the present . . .<br/><br/> A compelling family saga perfect for fans of Katie Flynn, Rosie Goodwin and Cathy Sharp.<br/>  <br/> Praise for the writing of Josephine Cox:<br/>  <br/> “Hailed quite rightly as a gifted writer in the tradition of Catherine Cookson.” —<i>Manchester Evening News</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Josephine Cox
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4567eeca